import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import { sortBillingPeriodsByLatest } from '../../utils/helpers';

import {
  BILLING_PERIODS_FETCH,
  BILLING_PERIODS_RECEIVE,
  SET_ACTIVE_BILLING_PERIOD,
  INVOICES_FETCH,
  INVOICES_RECEIVE,
  INVOICES_RESET,
  INVOICES_INITIALIZE, RECEIVE_ZUORA_SIGNATURE, SET_DEFAULT_PAYMENT_METHOD_FINISHED,
} from './constants';

const initialState = fromJS({
  fetching: false,
  billingPeriods: null,
  invoicesError: null,
  invoices: [],
  fetchingInvoices: false,
  zuoraIdFetchFinished: false,
  zuoraSignature: null,
});

export const reducer = handleActions({
  [BILLING_PERIODS_FETCH]: (state) => (
    state
      .set('fetching', true)
  ),

  [BILLING_PERIODS_RECEIVE]: (state, action) => (
      state
        .set('fetching', false)
        .set('error', null)
        .set('billingPeriods', fromJS(sortBillingPeriodsByLatest(action.payload.data)))
    ),

  [SET_ACTIVE_BILLING_PERIOD]: (state, action) => (
    state
      .set('activeBillingPeriod', fromJS(action.payload.billingPeriod))
  ),

  [INVOICES_FETCH]: (state) => (
    state
      .set('fetchingInvoices', true)
  ),

  [INVOICES_INITIALIZE]: (state) => (
    state
      .set('fetchingInvoices', true)
  ),

  [INVOICES_RECEIVE]: (state, action) => {
    const invoices = state.get('invoices');

    return state
      .set('fetchingInvoices', false)
      .set('invoices', fromJS([...invoices, ...action.payload]))
  },

  [INVOICES_RESET]: (state) => (
    state
      .set('invoices', fromJS([]))
  ),
  [RECEIVE_ZUORA_SIGNATURE]: (state, action) => (
    state
      .set('zuoraSignature', action.payload.signatureObject)
  ),
  [SET_DEFAULT_PAYMENT_METHOD_FINISHED]: (state) => (
    state
      .set('setDefaultPaymentMethodFinished', true)
  ),

}, initialState);

export default reducer
